import basicOptions from '@/router/basic-options';
import { userPermission } from '@/constants';
import WorkerAdjustment from '@/views/WorkerAdjustment/index.vue';
import { pageAuthorization } from '@/router-middleware';
import { defineAsyncComponent } from 'vue';
import { routeName } from '@/constants/routeName';
export default [
    {
        path: 'worker-adjustment',
        name: routeName.WORKER_ADJUSTMENT,
        component: WorkerAdjustment,
        redirect: {
            name: routeName.WITHHOLD_TAX_REPORT,
        },
        children: [
            {
                path: 'withhold-tax-report',
                name: routeName.WITHHOLD_TAX_REPORT,
                component: () => import('@/views/WorkerAdjustment/WithholdTaxReport/index.vue'),
                meta: {
                    ...basicOptions,
                    breadcrumbsItems: basicOptions.breadcrumbsItems.worker.adjustment,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_WORKER_ADJUSTMENT,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
            {
                path: 'simple-payment-detail',
                name: routeName.SIMPLE_PAYMENT_DETAIL,
                component: defineAsyncComponent(() => import('@/views/WorkerAdjustment/SimplePaymentDetail/index.vue')),
                meta: {
                    ...basicOptions,
                    breadcrumbsItems: basicOptions.breadcrumbsItems.worker.adjustment,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_WORKER_ADJUSTMENT,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
            {
                // 라이더별 상세조회
                path: 'details-per-worker',
                name: routeName.DETAILS_PER_WORKER,
                component: defineAsyncComponent(() => import('@/views/WorkerAdjustment/DetailsPerWorker/index.vue')),
                meta: {
                    ...basicOptions,
                    breadcrumbsItems: basicOptions.breadcrumbsItems.worker.adjustment,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_WORKER_ADJUSTMENT,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
            {
                path: 'payment-detail',
                name: routeName.PAYMENT_DETAIL,
                component: defineAsyncComponent(() => import('@/views/WorkerAdjustment/PaymentDetail/index.vue')),
                meta: {
                    ...basicOptions,
                    breadcrumbsItems: basicOptions.breadcrumbsItems.worker.adjustment,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_WORKER_ADJUSTMENT,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
        ],
    },
    {
        // 라이더별 상세조회 > 라이더 상세조회
        path: 'worker-adjustment/details-per-worker/:code/detail',
        name: routeName.WORKER_INFORMATION_DETAIL,
        component: defineAsyncComponent(() => import('@/views/WorkerAdjustment/DetailsPerWorker/Detail/index.vue')),
        meta: {
            ...basicOptions,
            breadcrumbsItems: basicOptions.breadcrumbsItems.worker.adjustment,
            middleware: [
                pageAuthorization([
                    userPermission.P_GET_WORKER_ADJUSTMENT,
                ]),
                ...basicOptions.middleware,
            ],
        },
    },
];
